export const CUBIC_WEB_ORIGIN = 'https://www.cubic.dev';

export const MAX_HANDOFF_URL_LENGTH = 2_000;

/** `?open_in=browser` keeps a page in the browser instead of opening it in the desktop app. */
export const OPEN_IN_PARAM = 'open_in';
export const OPEN_IN_BROWSER = 'browser';

export type DesktopHandoffRouteFamily = 'pr' | 'inbox';
